import React, { useContext } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';

export default function RestraintCheckListHistory(props) {

    const { theme } = useContext(Theme);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);
    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    return (
        <div>
            <MaterialTable
                title=""
                columns={props.restraintCheckListHistoryItem.columns}
                data={props.restraintCheckListHistoryItem.data}
                components={{
                    Toolbar: (prop) => (
                        <div
                            style={{
                                height: "0px",
                            }}
                        >
                            <MTableToolbar {...prop} />
                        </div>
                    )
                }}
                style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                options={{
                    filtering: false,
                    search: false,
                    paging: false,
                    actionsColumnIndex: -1,
                    minBodyHeight: "55vh", maxBodyHeight: "55vh",
                    headerStyle: {
                        fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                    },
                    actionsCellStyle: {
                        color: currentTheme.secondary,
                        hover: 'white'
                    },
                    rowStyle: rowStyle
                }}
            />
        </div>
    );
}